import { Component, Input, Output, EventEmitter, OnInit } from '@angular/core';
import { CommunicationService } from '../../services/communication.service';
import { FruHttpService } from '../../services/fru-http.service';
import { State } from '../state';

@Component({
  selector: 'app-states-dropdown',
  templateUrl: './states-dropdown.component.html',
  styleUrls: ['./states-dropdown.component.scss']
})
export class StatesDropdownComponent implements OnInit {
  @Input() initialState: string;
  @Input() className: string;
  @Input() showError = false;
  @Output() selected = new EventEmitter();
  states: State[];

  constructor(private fruHttpService: FruHttpService, private communication: CommunicationService) {
    this.fruHttpService.getStatesList().subscribe((states: State[]) => {
      const firstElement = { state: '', state_name: 'Select Your State', };
      // console.log('%c states ', 'color:orange;text-transform: uppercase;', states);
      this.states = [firstElement, ...states.filter(x => x.enabled == 1)];
    });
  }

  ngOnInit(): void {
    this.className = this.className || '';
  }

  selectState(state: string) {
    this.communication.state = this.states.find(x => x.state === state);
    this.selected.emit(state);
  }
}
